module.exports = __webpack_public_path__ + "img/seeker-profile-placeholder.f7159fa2.png";